/**
 * @fileoverview Connect explicit manual matter creation to the backend case-opening boundary. The form owns draft client, attorney, jurisdiction, and case choices; accepted matter identity and associated effects belong to the backend. `kc-internal-backend/functions/new_case.py` owns execution separately from won-deal onboarding.
 */

import React, { useState, useContext } from "react";
import Button from "../shared/AppPrimeButton";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Calendar } from "primereact/calendar";
import ToastContext from '../../ToastContext';
import api from "../../api";

const stages = {
  1: 'Pre-Demand',
  2: 'Demand Sent',
  3: 'Arbitration-AAA',
  4: 'Arbitration-JAMS',
  5: 'Arbitration-Other',
  6: 'State Court',
  7: 'Federal Court',
  8: 'Appeal',
  9: 'Post Judgment',
  10: 'Settled/Resolved',
  11: 'Withdrawn'
};

const reversedStages = Object.fromEntries(
  Object.entries(stages).map(([key, value]) => [value, parseInt(key)])
);



function getStageNumber(stageString) {
  return reversedStages[stageString];
}



function NewCase() {

  const showToast = useContext(ToastContext);

  const [matterNumber, setMatterNumber] = useState('');
  const [dateEngaged, setDateEngaged] = useState(new Date());
  const [stage, setStage] = useState(stages[1]);
  const [jurisdiction, setJurisdiction] = useState('');
  const [caseNumber, setCaseNumber] = useState('');

  const normalizedMatterNumber = matterNumber.trim();
  const matterNumberHasWhitespace = /\s/.test(normalizedMatterNumber);
  const matterNumberInvalid = !normalizedMatterNumber || matterNumberHasWhitespace;

  const createCase =

  async () => {
    if (matterNumberInvalid) {
      showToast({ severity: 'error', summary: 'Check matter number', detail: matterNumberHasWhitespace ? 'Matter numbers cannot contain spaces.' : 'Matter number is required.' });
      return;
    }
    console.log('stage', stage);
    console.log('stage number', getStageNumber(stage));
    const data = {
      MatterNumber: normalizedMatterNumber,
      DateEngaged: dateEngaged,
      Stage: getStageNumber(stage),
      Jurisdiction: jurisdiction,
      CaseNumber: caseNumber
    };

    api.post('/case', data).then((response) => {
      showToast({ severity: 'success', summary: 'Success', detail: 'Case Created' });
      // Open /case_details/matterNumber in new tab
      window.open(`/case_details/${normalizedMatterNumber}`, '_blank');
    }).catch((error) => {
      showToast({ severity: 'error', summary: 'Error', detail: 'Case Creation Failed' });
    });
  };

  const resetForm =

  () => {
    setMatterNumber('');
    setDateEngaged(new Date());
    setStage(stages[1]);
    setJurisdiction('');
    setCaseNumber('');
  };


  return (
    <div>
            <div className=''>
                    <div className="grid formgrid p-fluid">

                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="matter_number" className="font-medium text-900">Matter Number</label>
                            <InputText id="matter_number" type="text" value={matterNumber} invalid={matterNumberHasWhitespace} onChange={(e) => setMatterNumber(e.target?.value)} />
                            {matterNumberHasWhitespace && <small className="p-error">Remove spaces from the matter number.</small>}
                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="jurisdiction" className="font-medium text-900">Jurisdiction</label>
                            <InputText id="jurisdiction" type="text" value={jurisdiction} onChange={(e) => setJurisdiction(e.target?.value)} />
                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="stage" className="font-medium text-900">Stage</label>
                            {/* <Dropdown id="stage" value={stage} options={stages} onChange={(e) => setStage(e.value)} optionLabel="name" optionValue="name" placeholder="Select a Stage" /> */}
                            <Dropdown
              value={stage}
              options={Object.entries(stages).map(([key, value]) => ({ label: value, value: value }))}
              onChange={(e) => setStage(e.value)} />

                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="case_number" className="font-medium text-900">Case Number</label>
                            <InputText id="case_number" type="text" value={caseNumber} onChange={(e) => setCaseNumber(e.target?.value)} />
                        </div>
                        <div className="field mb-4 col-12 md:col-6">
                            <label htmlFor="date_engaged" className="font-medium text-900">Date Engaged</label>
                            <Calendar id="date_engaged" value={dateEngaged} onChange={(e) => setDateEngaged(e.value)} dateFormat="mm/dd/yy" />
                        </div>

                        <div className="surface-border border-top-1 opacity-50 mb-4 col-12"></div>
                    </div>
                    <Button label="Create Case" icon="pi pi-Calendar" className="w-auto" onClick={createCase} disabled={matterNumberInvalid} />
                    <Button label="Reset" icon="pi pi-undo" className="w-auto ml-3" onClick={resetForm} outlined />
                </div>
            </div>);

}

export default NewCase;
